import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'
import iView from 'iview'
import locale from 'iview/dist/locale/id-ID'

const Home = () => import(/* webpackChunkName: "AUTH" */'@/views/auth/Home')
const Login = () => import(/* webpackChunkName: "AUTH" */'@/views/auth/Index')
const Dashboard = () => import(/* webpackChunkName: "Dashboard Index" */'@/views/dashboard/Index')
const Biodata = () => import(/* webpackChunkName: "Biodata" */'@/views/dashboard/biodata/TheTabs')
const Verifikasi = () => import(/* webpackChunkName: "Verifikasi" */'@/views/dashboard/verifikasi/Index')
const Ujian = () => import(/* webpackChunkName: "Ujian" */'@/views/dashboard/ujian/Index')
const Petugas = () => import(/* webpackChunkName: "Petugas" */'@/views/dashboard/petugas/Index')
const Penempatan = () => import(/* webpackChunkName: "Petugas" */'@/views/dashboard/petugas/Penempatan')
const DashboardAdmin = () => import(/* webpackChunkName: "Dashboard" */'@/views/dashboard/dashboard-admin/rekap-prov/Index')
const KantorWilayah = () => import(/* webpackChunkName: "KantorWilayah" */'@/views/dashboard/kanwil/Index')
const UserMgmt = () => import(/* webpackChunkName: "UserMgmt" */'@/views/dashboard/user-mgmt/Index')
const SetupHaji = () => import(/* webpackChunkName: "SetupHaji" */'@/views/dashboard/setup-haji/Index')
const UploadVerifikasi = () => import(/* webpackChunkName: "UploadVerifikasi" */'@/views/dashboard/upload-verifikasi/Index')
const PersetujuanPendaftaran = () => import(/* webpackChunkName: "UploadVerifikasi" */'@/views/dashboard/persetujuan-pendaftaran/Index')
const MonitoringPersetujuanPendaftaran = () => import(/* webpackChunkName: "UploadVerifikasi" */'@/views/dashboard/persetujuan-pendaftaran/Monitoring')
const BankSoal = () => import(/* webpackChunkName: "BankSoal" */'@/views/dashboard/bank-soal/Index')
const BingasPusat = () => import(/* webpackChunkName: "BingasPusat" */'@/views/dashboard/bingas-pusat/Index')
const ReferensiMaster = () => import(/* webpackChunkName: "Referensi" */'@/views/dashboard/referensi-master/Index')
const ForgotPassword = () => import(/* webpackChunkName: "ForgotPassword" */'@/views/auth/ForgotPassword')
const ResetStatusPendaftar = () => import(/* webpackChunkName: "Referensi" */'@/views/dashboard/reset-status-pendaftar/Index')
const ResetStatusPrapendaftar = () => import(/* webpackChunkName: "Referensi" */'@/views/dashboard/reset-prapendaftaran/Index')
const ResetStatusMcu = () => import(/* webpackChunkName: "Referensi" */'@/views/dashboard/reset-status-mcu/Index')
const ResetTitikLokasiJenisTugas = () => import(/* webpackChunkName: "Referensi" */'@/views/dashboard/reset-lokasi-jenis-tugas/Index')
const ResetNik = () => import(/* webpackChunkName: "Referensi" */'@/views/dashboard/reset-nik/Index')
const PesertaUnHistory = () => import(/* webpackChunkName: "Referensi" */'@/views/dashboard/ujian/PesertaUnHistory')
const VerifikasiPemvisaan = () => import(/* webpackChunkName: "Verifikasi" */'@/views/dashboard/verifikasi/VerifikasiPemvisaan')
const VerifikasiPaspor = () => import(/* webpackChunkName: "Verifikasi" */'@/views/dashboard/verifikasi/VerifikasiPaspor')
const VerifikasiMcu = () => import(/* webpackChunkName: "Verifikasi" */'@/views/dashboard/verifikasi/VerifikasiMCU')
const BiodataPL = () => import(/* webpackChunkName: "Biodata" */'@/views/dashboard/biodata/TheTabsPL')
const BiodataKesehatan = () => import(/* webpackChunkName: "Biodata" */'@/views/dashboard/biodata/TheTabsKesehatan')
const UjianBimtek = () => import(/* webpackChunkName: "Bimtek" */'@/views/dashboard/bimtek/Index')
const Moderator = () => import(/* webpackChunkName: "Bimtek" */'@/views/dashboard/bimtek/Moderator')
const Narasumber = () => import(/* webpackChunkName: "Bimtek" */'@/views/dashboard/bimtek/Narasumber')
const Materi = () => import(/* webpackChunkName: "Bimtek" */'@/views/dashboard/bimtek/Materi')
const Presensi = () => import(/* webpackChunkName: "Bimtek" */'@/views/dashboard/bimtek/Presensi')
const RekapPresensi = () => import(/* webpackChunkName: "Bimtek" */'@/views/dashboard/bimtek/RekapPresensi')
const RekapPresensiByPetugas = () => import(/* webpackChunkName: "Bimtek" */'@/views/dashboard/bimtek/RekapPresensiByPetugas')
const MonitoringKatering = () => import(/* webpackChunkName: "Monitoring" */'@/views/dashboard/monitoring/MonitoringKatering')
const MonitoringTransportasi = () => import(/* webpackChunkName: "Monitoring" */'@/views/dashboard/monitoring/MonitoringTransportasi')
const MonitoringTransportasiShalawat = () => import(/* webpackChunkName: "Monitoring" */'@/views/dashboard/monitoring/MonitoringTransportasiShalawat')
const MonitoringPembayaranDam = () => import(/* webpackChunkName: "Monitoring" */'@/views/dashboard/monitoring/MonitoringPembayaranDam')
const MonitoringLapKeberangkatan = () => import(/* webpackChunkName: "Monitoring" */'@/views/dashboard/monitoring/MonitoringLapKeberangkatan')
const MonitoringLapKedatangan = () => import(/* webpackChunkName: "Monitoring" */'@/views/dashboard/monitoring/MonitoringLapKedatangan')
const MonitoringPenkin = () => import(/* webpackChunkName: "Monitoring" */'@/views/dashboard/monitoring/MonitoringPenkin')
const MonitoringPetugasPenkin = () => import(/* webpackChunkName: "Monitoring" */'@/views/dashboard/monitoring/MonitoringPetugasPenkin')
const MonitoringLokasiPetugas = () => import(/* webpackChunkName: "Monitoring" */'@/views/dashboard/monitoring/MonitoringLokasiPetugas')
const MonitoringKebutuhanKhusus = () => import(/* webpackChunkName: "Monitoring" */'@/views/dashboard/monitoring/MonitoringKebutuhanKhusus')
const InputPembayaranDam = () => import(/* webpackChunkName: "PembayaranDam" */'@/views/dashboard/pembayaran-dam/Index')
const MasterBus = () => import(/* webpackChunkName: "Transportasi" */'@/views/dashboard/transportasi/MasterBus')
const RekapHarian = () => import(/* webpackChunkName: "Dashboard" */'@/views/dashboard/dashboard-admin/rekap-harian/Index')
const RekapKabKota = () => import(/* webpackChunkName: "Dashboard" */'@/views/dashboard/dashboard-admin/rekap-kabkota/Index')
const RekapPerTahap = () => import(/* webpackChunkName: "Dashboard" */'@/views/dashboard/dashboard-admin/rekap-tahap/Index')
const RekapKloterNK = () => import(/* webpackChunkName: "Dashboard" */'@/views/dashboard/dashboard-admin/rekap-kloter-nk/Index')
const RekapFormasi = () => import(/* webpackChunkName: "Dashboard" */'@/views/dashboard/dashboard-admin/rekap-formasi/Index')
const MonitoringUjianTahap1 = () => import(/* webpackChunkName: "Monitoring Ujain/Test" */'@/views/dashboard/monitoring-ujian-test/MonitoringUjianTahap1')
const MonitoringUjianTahap2 = () => import(/* webpackChunkName: "Monitoring Ujain/Test" */'@/views/dashboard/monitoring-ujian-test/MonitoringUjianTahap2')
const MonitoringUjianMahasiswa = () => import(/* webpackChunkName: "Monitoring Ujain/Test" */'@/views/dashboard/monitoring-ujian-test/MonitoringUjianMahasiswa')
const MonitoringUjianMukimin = () => import(/* webpackChunkName: "Monitoring Ujain/Test" */'@/views/dashboard/monitoring-ujian-test/MonitoringUjianMukimin')
const MonitoringPrePostTest = () => import(/* webpackChunkName: "Monitoring Ujain/Test" */'@/views/dashboard/monitoring-ujian-test/MonitoringPrePostTest')
// const InputNoWhatsapp = () => import(/* webpackChunkName: "AUTH" */'@/views/auth/InputNoWhatsApp')
// const VerifNoWhatsapp = () => import(/* webpackChunkName: "AUTH" */'@/views/auth/VerifNoWhatsApp')
const FormPendaftaran = () => import(/* webpackChunkName: "AUTH" */'@/views/auth/FormPendaftaran')
const FormPendaftaranKesehatan = () => import(/* webpackChunkName: "AUTH" */'@/views/auth/FormPendaftaranKesehatan')
const FormPendaftaranMukimin = () => import(/* webpackChunkName: "AUTH" */'@/views/auth/FormPendaftaranMukimin')
const InputEmail = () => import(/* webpackChunkName: "AUTH" */'@/views/auth/InputEmail')
const VerifEmail = () => import(/* webpackChunkName: "AUTH" */'@/views/auth/VerifEmail')
const InputEmailKesehatan = () => import(/* webpackChunkName: "AUTH" */'@/views/auth/InputEmailKesehatan')
const VerifEmailKesehatan = () => import(/* webpackChunkName: "AUTH" */'@/views/auth/VerifEmailKesehatan')
const ResetLockBiodataPemvisaan = () => import(/* webpackChunkName: "AUTH" */'@/views/dashboard/reset-lock-biodata-pemvisaan/Index')
const EvaluasiNarsumFasil = () => import(/* webpackChunkName: "AUTH" */'@/views/dashboard/evaluasi/narasumber_fasilitator')
const EvaluasiLayananPenyelenggara = () => import(/* webpackChunkName: "AUTH" */'@/views/dashboard/evaluasi/layanan_penyelenggara')
const VerifPublic = () => import(/* webpackChunkName: "AUTH" */'@/views/auth/VerifPublic')
const BerhakUjian = () => import(/* webpackChunkName: "AUTH" */'@/views/dashboard/berhak-ujian/Index')
const BerhakUjianDaerah = () => import(/* webpackChunkName: "AUTH" */'@/views/dashboard/berhak-ujian/IndexDaerah')

Vue.use(Router)
Vue.use(iView, { locale })

iView.LoadingBar.config({
  color: "#fff",
  height: 4
})

const router = new Router({
  linkActiveClass: 'active',
  routes: [
    {
      path: '/home',
      name: 'Home',
      component: Home,
      beforeEnter: (to, from, next) => {
        if (!store.state.role_id) {
          next()
        } else {
          next('/')
        }
      }
    },
    {
      path: '/',
      name: 'Dashboard',
      component: Dashboard,
      beforeEnter: (to, from, next) => {
        if (store.state.role_id) {
          next()
        } else {
          next('/home')
        }
      },
      children: [
        {
          path: '/biodata',
          name: 'Biodata',
          component: Biodata
        },
        {
          path: '/verifikasi',
          name: 'Verifikasi',
          component: Verifikasi
        },
        {
          path: '/berhak_ujian',
          name: 'BerhakUjian',
          component: BerhakUjian
        },
        {
          path: '/berhak_ujian_daerah',
          name: 'BerhakUjianDaerah',
          component: BerhakUjianDaerah
        },
        {
          path: '/ujian',
          name: 'Ujian',
          component: Ujian
        },
        {
          path: '/petugas',
          name: 'Petugas',
          component: Petugas
        },
        {
          path: '/penempatan',
          name: 'Penempatan',
          component: Penempatan
        },
        {
          path: '/ujian_bimtek',
          name: 'UjianBimtek',
          component: UjianBimtek
        },
        {
          path: '/narasumber',
          name: 'Narasumber',
          component: Narasumber
        },
        {
          path: '/moderator',
          name: 'Moderator',
          component: Moderator
        },
        {
          path: '/materi',
          name: 'Materi',
          component: Materi
        },
        {
          path: '/presensi',
          name: 'Presensi',
          component: Presensi
        },
        {
          path: '/rekap_presensi',
          name: 'RekapPresensi',
          component: RekapPresensi
        },
        {
          path: '/rekap_presensi_by_petugas',
          name: 'RekapPresensiByPetugas',
          component: RekapPresensiByPetugas
        },
        {
          // path: '/dashboard',
          path: '/dashboard/rekap_kanwil',
          name: 'DashboardAdmin',
          component: DashboardAdmin
        },
        {
          path: '/dashboard/rekap_harian',
          name: 'RekapHarian',
          component: RekapHarian
        },
        {
          path: '/dashboard/rekap_kabkota',
          name: 'RekapKabKota',
          component: RekapKabKota
        },
        {
          path: '/dashboard/rekap_tahap',
          name: 'RekapPerTahap',
          component: RekapPerTahap
        },
        {
          path: '/dashboard/rekap_kloter_nk',
          name: 'RekapKloterNK',
          component: RekapKloterNK
        },
        {
          path: '/dashboard/rekap_formasi',
          name: 'RekapFormasi',
          component: RekapFormasi
        },
        {
          path: '/kantor_wilayah',
          name: 'KantorWilayah',
          component: KantorWilayah
        },
        {
          path: '/usermgmt',
          name: 'UserMgmt',
          component: UserMgmt
        },
        {
          path: '/setuphaji',
          name: 'SetupHaji',
          component: SetupHaji
        },
        {
          path: '/upload_verifikasi',
          name: 'Upload_Verifikasi',
          component: UploadVerifikasi
        },
        {
          path: '/bank_soal',
          name: 'BankSoal',
          component: BankSoal
        },
        {
          path: '/bingas_pusat',
          name: 'Bingas_Pusat',
          component: BingasPusat
        },
        {
          path: '/referensi',
          name: 'ReferensiMaster',
          component: ReferensiMaster
        },
        {
          path: '/reset_status',
          name: 'ResetStatusPendaftar',
          component: ResetStatusPendaftar
        },
        {
          path: '/reset_status_mcu',
          name: 'ResetStatusMcu',
          component: ResetStatusMcu
        },
        {
          path: '/reset_prapendaftaran',
          name: 'ResetStatusPraPendaftar',
          component: ResetStatusPrapendaftar
        },
        {
          path: '/reset_titik_lokasi_jenis_tugas',
          name: 'ResetTitikLokasiJenisTugas',
          component: ResetTitikLokasiJenisTugas
        },
        {
          path: '/reset_nik',
          name: 'ResetNik',
          component: ResetNik
        },
        {
          path: '/reset_lock_biodata_pemvisaan',
          name: 'ResetLockBiodataPemvisaan',
          component: ResetLockBiodataPemvisaan
        },
        {
          path: '/peserta_unhistory',
          name: 'PesertaUnHistory',
          component: PesertaUnHistory
        },
        {
          path: '/verifikasi_pemvisaan',
          name: 'VerifikasiPemvisaan',
          component: VerifikasiPemvisaan
        },
        {
          path: '/verifikasi_paspor',
          name: 'VerifikasiPaspor',
          component: VerifikasiPaspor
        },
        {
          path: '/verifikasi_mcu',
          name: 'VerifikasiMcu',
          component: VerifikasiMcu
        },
        {
          path: '/biodata_pl',
          name: 'BiodataPL',
          component: BiodataPL
        },
        {
          path: '/biodata_kesehatan',
          name: 'BiodataKesehatan',
          component: BiodataKesehatan
        },
        {
          path: '/m_katering',
          name: 'MonitoringKatering',
          component: MonitoringKatering
        },
        {
          path: '/m_transportasi',
          name: 'MonitoringTransportasi',
          component: MonitoringTransportasi
        },
        {
          path: '/m_transportasi_shalawat',
          name: 'MonitoringTransportasiShalawat',
          component: MonitoringTransportasiShalawat
        },
        {
          path: '/m_pembayaran_dam',
          name: 'MonitoringPembayaranDam',
          component: MonitoringPembayaranDam
        },
        {
          path: '/m_keberangkatan',
          name: 'MonitoringKeberangkatan',
          component: MonitoringLapKeberangkatan
        },
        {
          path: '/m_kedatangan',
          name: 'MonitoringKedatangan',
          component: MonitoringLapKedatangan
        },
        {
          path: '/m_penkin',
          name: 'MonitoringPenkin',
          component: MonitoringPenkin
        },
        {
          path: '/m_penkin_petugas',
          name: 'MonitoringPetugasPenkin',
          component: MonitoringPetugasPenkin
        },
        {
          path: '/pembayaran_dam',
          name: 'InputPembayaranDam',
          component: InputPembayaranDam
        },
        {
          path: '/persetujuan_pendaftaran',
          name: 'Persetujuan_Pendaftaran',
          component: PersetujuanPendaftaran
        },
        {
          path: '/monitoring_prapendaftaran',
          name: 'Monitoring_Persetujuan_Pendaftaran',
          component: MonitoringPersetujuanPendaftaran
        },
        {
          path: '/m_lokasi',
          name: 'MonitoringLokasiPetugas',
          component: MonitoringLokasiPetugas
        },
        {
          path: '/m_kebutuhan_khusus',
          name: 'MonitoringKebutuhanKhusus',
          component: MonitoringKebutuhanKhusus
        },
        {
          path: '/master_bus',
          name: 'MasterBus',
          component: MasterBus
        },
        {
          path: '/ujian_tahap_1',
          name: 'UjianTahap1',
          component: MonitoringUjianTahap1
        },
        {
          path: '/ujian_tahap_2',
          name: 'UjianTahap2',
          component: MonitoringUjianTahap2
        },
        {
          path: '/ujian_mahasiswa',
          name: 'UjianMahasiswa',
          component: MonitoringUjianMahasiswa
        },
        {
          path: '/ujian_mukimin',
          name: 'UjianMukimin',
          component: MonitoringUjianMukimin
        },
        {
          path: '/pre_post_test',
          name: 'PrePostTest',
          component: MonitoringPrePostTest
        },
        {
          path: '/evaluasi_narsum_fasil',
          name: 'EvaluasiNarsumFasil',
          component: EvaluasiNarsumFasil
        },
        {
          path: '/evaluasi_layanan_penyelenggara',
          name: 'EvaluasiLayananPenyelenggara',
          component: EvaluasiLayananPenyelenggara
        }
      ]
    },
    {
      path: '/reset_password/:token',
      component: ForgotPassword
    },
    /* {
      path: '/input_wa',
      component: InputNoWhatsapp
    },
    {
      path: '/verif_wa',
      component: VerifNoWhatsapp
    },*/
    {
      path: '/input_email',
      component: InputEmail
    },
    {
      path: '/verif_email',
      component: VerifEmail
    },
    {
      path: '/registrasi',
      component: FormPendaftaran
    },
    {
      path: '/input_email_kesehatan',
      component: InputEmailKesehatan
    },
    {
      path: '/verif_email_kesehatan',
      component: VerifEmailKesehatan
    },
    {
      path: '/registrasi_kesehatan',
      component: FormPendaftaranKesehatan
    },
    {
      path: '/registrasi_mukimin',
      component: FormPendaftaranMukimin
    },
    {
      path: '/verif/:id',
      component: VerifPublic
    }
  ]
})

router.beforeEach((to, from, next) => {
  iView.LoadingBar.start()

  // if (to.path === "/") {

  //   if (store.state.role_id === "3") {
  //     next('/biodata')
  //   } else if (store.state.role_id === "2") {
  //     next('/upload_verifikasi')
  //   } else if (store.state.role_id === "1") {
  //     next('/dashboard')
  //   } else {
  //     next('/home')
  //   }

  // } else {
  //   next();
  // }
  next();
})

router.afterEach(route => {
  iView.LoadingBar.finish()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js